import {
  CONNECTION_NAME,
  CREATED_BY,
  DATE_RANGE,
  INVOICE_AMOUNT,
  INVOICE_DATE,
  INVOICE_DUE_DATE,
  INVOICE_ISSUE_DATE,
  INVOICE_STATUS,
  INVOICE_WORK_ORDER,
} from "~/constants/filters/filters";

const defaultInvoiceFilters = {
  [INVOICE_STATUS]: [],
  [CONNECTION_NAME]: [],
  [INVOICE_DATE]: [],
  [DATE_RANGE]: [],
  [INVOICE_AMOUNT]: [],
  [INVOICE_ISSUE_DATE]: [],
  [INVOICE_DUE_DATE]: [],
  [CREATED_BY]: [],
};

const pickFilter = (
  activeFilters: Record<string, unknown>,
  key: string,
): unknown[] | undefined => {
  const value = activeFilters[key];
  if (!Array.isArray(value) || value.length === 0) return undefined;
  return value;
};

const toIsoDateRange = (dates: unknown[]) => {
  if (!Array.isArray(dates) || dates.length < 2) return undefined;
  const start = new Date(dates[0] as string | Date).toISOString();
  const end = new Date(dates[1] as string | Date).toISOString();
  return [start, end];
};

export const buildFinanceInvoicesWhere = (
  activeFilters: Record<string, unknown> = defaultInvoiceFilters,
  searchQuery?: string,
) => {
  const status_in = pickFilter(activeFilters, INVOICE_STATUS) as
    | string[]
    | undefined;
  const company_in = pickFilter(activeFilters, CONNECTION_NAME) as
    | string[]
    | undefined;
  const workOrder_in = pickFilter(activeFilters, INVOICE_WORK_ORDER) as
    | string[]
    | undefined;
  const date = toIsoDateRange(
    (pickFilter(activeFilters, INVOICE_DATE) as unknown[]) ??
      (pickFilter(activeFilters, DATE_RANGE) as unknown[]) ??
      [],
  );
  const amountRaw = pickFilter(activeFilters, INVOICE_AMOUNT);
  const issueDate = toIsoDateRange(
    (pickFilter(activeFilters, INVOICE_ISSUE_DATE) as unknown[]) ?? [],
  );
  const dueDate = toIsoDateRange(
    (pickFilter(activeFilters, INVOICE_DUE_DATE) as unknown[]) ?? [],
  );
  const createdBy_in = pickFilter(activeFilters, CREATED_BY) as
    | string[]
    | undefined;

  let amount: (number | null)[] | undefined;
  if (Array.isArray(amountRaw) && amountRaw.length) {
    const min =
      amountRaw[0] === "" || amountRaw[0] == null ? null : Number(amountRaw[0]);
    const max =
      amountRaw[1] === "" || amountRaw[1] == null
        ? undefined
        : Number(amountRaw[1]);
    amount = max !== undefined ? [min ?? 0, max] : [min ?? 0];
  }

  return {
    ...(searchQuery?.trim() ? { searchQuery: searchQuery.trim() } : {}),
    ...(status_in ? { status_in } : {}),
    ...(company_in ? { company_in } : {}),
    ...(workOrder_in ? { workOrder_in } : {}),
    ...(date ? { date } : {}),
    ...(amount ? { amount } : {}),
    ...(issueDate ? { issueDate } : {}),
    ...(dueDate ? { dueDate } : {}),
    ...(createdBy_in ? { createdBy_in } : {}),
  };
};

export const buildListFinanceInvoicesVariables = ({
  activeFilters,
  searchQuery,
  limit,
  skip,
  sort = ["created_at:desc"],
}: {
  activeFilters?: Record<string, unknown>;
  searchQuery?: string;
  limit: number;
  skip: number;
  sort?: string[];
}) => ({
  params: {
    limit,
    skip,
    sort,
    where: buildFinanceInvoicesWhere(activeFilters, searchQuery),
  },
});
